import { attr, fk } from 'redux-orm'
import Base from './Base'

class BillingRun extends Base {
  static get fields () {
    return {
      id: attr(),
      periodStart: attr(),
      periodEnd: attr(),
      status: attr(),
      usageSnapshot: attr(),
      failureReason: attr(),
      createdAt: attr(),
      subscriptionId: fk('billingSubscription', 'runs'),
      billingInvoiceId: fk('billingInvoice', 'runs')
    }
  }
}

BillingRun.modelName = 'billingRun'

export default BillingRun
